module.exports = __webpack_public_path__ + "media/images/registrations/product_version/bg-04-e8e5119b1bd22a1300d39f5fe090d60d.png";